import {ChangeDetectorRef, Directive, HostBinding, HostListener, Input, OnInit} from '@angular/core';
import {fromEvent} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

@Directive({
  selector: '[back-to-top]'
})

export class BackTopDirective implements OnInit {

  @Input()
  private element: HTMLElement;
  private isVisible: boolean;

  constructor(private cd: ChangeDetectorRef) {

  }

  public ngOnInit(): void {
    fromEvent(window, 'scroll')
      .pipe(debounceTime(100))
      .subscribe(() => {
        this.isVisible = this.element.getBoundingClientRect().top < 0;
        this.cd.markForCheck();
      });
  }

  @HostBinding('style.display')
  public get display() {
    return this.isVisible ? 'block' : 'none';
  }

  @HostListener('click')
  public onClick() {
    window.scroll(0, 0);
  }
}
